type StateSafeIconProps = {
  size?: number
}

/** 시안 Icon/Normal/StateSafe — 입력이 통과했음을 알리는 동근 체크(666:28889 · 666:28893 의 Noti). */
export function StateSafeIcon({ size = 16 }: StateSafeIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99998 1.3337C9.76775 1.3338 11.4632 2.03588 12.7133 3.28581C13.9635 4.536 14.6664 6.23204 14.6664 8.00008C14.6664 9.3184 14.2752 10.6072 13.5429 11.7034C12.8105 12.7996 11.769 13.6541 10.551 14.1587C9.3329 14.6632 7.99203 14.7953 6.69888 14.5381C5.4059 14.2809 4.21794 13.6465 3.2857 12.7143C2.35339 11.782 1.71823 10.5934 1.46101 9.30024C1.2039 8.00727 1.33599 6.66699 1.84045 5.44904C2.34499 4.23097 3.1995 3.18967 4.29571 2.45716C5.39199 1.72465 6.68149 1.3337 7.99998 1.3337ZM7.04764 9.14772L5.42382 7.52391L4.66678 8.28094L7.04764 10.6618L11.336 6.3744L10.5761 5.61923L7.04764 9.14772Z"
        fill="currentColor"
      />
    </svg>
  )
}
